<div class="blog-follow-requests-holder">
  <div class="top-div">
    <div class="top-div-title">درخواست ها</div>
  </div>
  <div class="page-holder">
    <div
      *ngFor="let request of requests; let i = index"
      class="follow-requests-box"
      [ngStyle]="{ 'margin-top': i === 0 ? '16px' : '0' }"
    >
      <img
        *ngIf="request.avatarPath !== ''"
        src="{{ request.avatarPath }}"
        onerror="this.onerror=null; this.src='assets/blog/avatar.svg'"
        class="follow-requests-img"
        (click)="profile(request.userName)"
      />
      <img
        *ngIf="request.avatarPath === ''"
        src="assets/blog/avatar.svg"
        class="follow-requests-img"
        (click)="profile(request.userName)"
      />
      <div class="requests-username" (click)="profile(request.userName)">
        {{ request.userName }}
      </div>
      <div class="accept-requests" (click)="acceptFollowing(request.id)">
        قبول
      </div>
      <div class="decline-requests" (click)="rejectFollowing(request.id)">
        حذف
      </div>
    </div>
    <div
      class="more-requests"
      *ngIf="requestCount > (requestPage + 1) * requestPerPage"
    >
      <div class="more-requests-title" (click)="showMoreRequests()">
        درخواست‌های بیشتر
      </div>
    </div>
    <div *ngIf="requests.length === 0" class="empty-requests">
      درخواستی موجود نیست
    </div>
  </div>
  <!-- <div class="profile-page" id="profilePage{{ id }}" *ngIf="showProfile">
    <app-blog-profile
      [id]="profileId"
      [username]="selectedUsername"
      style="width: 100%; height: 100%"
    ></app-blog-profile>
    <div class="blog-back-holder" (click)="closeProfile()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div> -->
</div>
